import { useAuth } from "@/context/AuthContext";

// Renders children only for admin users. Used to gate export/download actions app-wide.
export function AdminOnly({ children }) {
  const { user } = useAuth();
  return (user?.role || "").toLowerCase() === "admin" ? children : null;
}
